<template>
  <v-card class="card" v-loading="loading">
    <v-card-title class="accent--text pb-4"><span class="card-title">Документы</span></v-card-title>
    <v-card-text outlined tile class="border-top">
      <v-container>
        <template v-if="documentsList.length">
          <v-row v-for="(item, i) in documentsList" :key="i">
            <v-col class="d-flex px-0 pb-0"  @click="selectItem(item)">
              <v-chip link class="accent--text">
                <v-icon left :color="toggleColorEye(item)">
                  mdi-eye-outline
                </v-icon>
                {{ item.originalName ? item.originalName : item.fileName }}
              </v-chip>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row>
            <v-col cols="12" class="pt-2 px-0">
              <div class="accent--text">Документы не были приложены</div>
            </v-col>
          </v-row>
        </template>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>

import { fileApi } from '@/api'
import { mapGetters } from 'vuex'
import {Application} from "@/models";

export default {
  name: "DocumentsCard",

  props: {
    application: Application
  },

  async created() {
    await this.getFiles()
  },

  data: () => ({
    documentsList: [],
    activeItem: {},
    loading: false
  }),

  methods: {
    async getFiles() {
      try {
        this.documentsList = []
        this.loading = true
        const data = await fileApi.findAllFilesByApplicationId(this.$route.params.id)
        this.documentsList.push(...data)
        this.activeItem = this.documentsList[0]
        if (this.documentsList.length) this.$emit('selectItem', this.documentsList[0])
      } catch (e) {
        this.$toastr('error', `<b>Код ошибки: ${e.status}</b>`, 'Возникла ошибка')
      } finally {
        this.loading = false
      }
    },

    selectItem(val) {
      this.activeItem = val
      this.$emit('selectItem', val)
    },

    toggleColorEye(val) {
      return this.activeItem.id === val?.id ? 'blue' : ''
    }
  },

  watch: {
    // 'application.applicationStatus.id': {
    //   async handler(value) {
    //     if ([1, 2].includes(value)) {
    //       await this.getFiles()
    //     }
    //   }
    // }
  }

}
</script>

<style scoped>
.card {
  border-radius: 20px !important;
}

.card-title {
  word-break: normal !important;
}

.border-top {
  border: 0 !important;
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>
